// Componente Angular con un formulario para editar los datos de una solicitud de vacaciones.
// Se importa en vacaciones.module.ts

import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AsuntosPropiosComponent } from "./asuntos-propios.component";
import { AsuntosPropiosService } from "../../../services/employees/asuntos-propios.service";
import { EmployeesListModel } from "../employees-list.model";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import moment from 'moment';
import { AsuntosPropios } from "../../../models/personal/asuntos-propios.models";

@Component({
    selector: "app-asuntos-propios-form",
    templateUrl: "./asuntos-propios-form.component.html",
    styleUrls: [],
    standalone: false
})
export class AsuntosPropiosFormComponent implements OnInit {
    // #region Propiedades del componente
    empleados: EmployeesListModel[] = [];
    form: UntypedFormGroup = null;
    asuntosPropios: AsuntosPropios = this.AsuntosPropiosService.newAsuntosPropios();
    // #endregion

    constructor(
        public dialogRef: MatDialogRef<AsuntosPropiosComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialog: MatDialog,
        protected snackBar: MatSnackBar,
        public AsuntosPropiosService: AsuntosPropiosService
    ) { }

    // #region Métodos del componente

    cancel(): void {
        this.dialogRef.close();
    }

    ngOnInit() {
        this.empleados = this.data.empleados;

        if (this.data.asuntosPropios != undefined) {
            this.asuntosPropios = this.data.asuntosPropios;
        } else {
            this.asuntosPropios = this.AsuntosPropiosService.newAsuntosPropios();
        }

        this.inicializarFormulario();
    }

    onSubmit() {
        if (this.form.valid) {

            this.asuntosPropios.employees_Id = this.form.value.employees_Id;
            this.asuntosPropios.inicio = this.form.value.inicio;
            this.asuntosPropios.fin = this.form.value.fin;
            this.asuntosPropios.motivo = this.form.value.motivo;

            if (this.asuntosPropios.id == 0) {
                // En el caso de que se esté creando una nueva solicitud de vacaciones, el estado debe ser igual a 2 porque se está añadiendo directamente en la administración
                // de vacaciones, sin pasar por la pantalla de solicitudes.
                this.asuntosPropios.estado = 2;
                this.asuntosPropios.fechaAprobacion = moment().toDate();
                this.asuntosPropios.fechaRechazo = null;
                this.asuntosPropios.motivoRechazo = null;
                this.asuntosPropios.fechaSolicitud = moment().toDate();
                this.asuntosPropios.users_id = 0;
            }

            this.AsuntosPropiosService.saveAsuntosPropios(this.asuntosPropios).subscribe({
                next: (resultado) => {
                    if (resultado) {
                        this.dialogRef.close();
                    }
                }
            });
        }
    }

    rechazar(): void {
        this.dialog.open(RechazarAsuntosPropiosComponent, {
            data: {
                title: "¿Seguro que quiere RECHAZAR la solicitud de vacaciones?",
            }
        })
            .afterClosed().subscribe((result: string) => {
                if (result.length > 0) {

                    // Rechazo de la solicitud de vacaciones seleccionada
                    this.asuntosPropios.estado = 3;
                    this.asuntosPropios.fechaAprobacion = null;
                    this.asuntosPropios.fechaRechazo = moment().toDate();
                    this.asuntosPropios.motivoRechazo = result;

                    this.AsuntosPropiosService.saveAsuntosPropios(this.asuntosPropios).subscribe({
                        next: (resultado) => {
                            if (resultado) {

                                this.snackBar.open("Solicitud de asuntos propios RECHAZADA", null, {
                                    duration: 3000,
                                });

                                this.dialogRef.close();
                            }
                        }
                    });
                }
            });
    }

    validar(): void {
        this.dialog.open(ValidarAsuntosPropiosComponent, {
            data: {
                title: "¿Seguro que quiere VALIDAR la solicitud de asuntos propios?",
            }
        })
            .afterClosed().subscribe((result: boolean) => {
                if (result) {

                    // Validación de las asuntos propios seleccionadas
                    this.asuntosPropios.estado = 2;
                    this.asuntosPropios.fechaAprobacion = moment().toDate();
                    this.asuntosPropios.fechaRechazo = null;
                    this.asuntosPropios.motivoRechazo = null;

                    this.AsuntosPropiosService.saveAsuntosPropios(this.asuntosPropios).subscribe({
                        next: (resultado) => {
                            if (resultado) {

                                this.snackBar.open("Solicitud de asuntos propios VALIDADA", null, {
                                    duration: 3000,
                                });

                                this.dialogRef.close();
                            }
                        }
                    });
                }
            });
    }

    // #endregion

    // #region Métodos privados del componente

    private inicializarFormulario(): void {
        this.form = new UntypedFormGroup({
            employees_Id: new UntypedFormControl(
                this.asuntosPropios.employees_Id,
                Validators.required
            ),
            inicio: new UntypedFormControl(this.asuntosPropios.inicio, Validators.required),
            fin: new UntypedFormControl(this.asuntosPropios.fin, Validators.required),
            motivo: new UntypedFormControl(this.asuntosPropios.motivo, Validators.required),
        });
    }

    // #endregion
}

@Component({
    selector: 'validar-asuntos-propios',
    templateUrl: 'validar-asuntos-propios.component.html',
    standalone: false
})
export class ValidarAsuntosPropiosComponent implements OnInit {
    title: string = "";
    constructor(
        private dialogRef: MatDialogRef<ValidarAsuntosPropiosComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.title = this.data.title;
    }

    ngOnInit(): void {
        this.title = this.data.title;
    }

    rechazar(): void {
        this.dialogRef.close(false);
    }

    validar(): void {
        this.dialogRef.close(true);
    }
}

@Component({
    selector: 'rechazar-asuntos-propios',
    templateUrl: 'rechazar-asuntos-propios.component.html',
    standalone: false
})
export class RechazarAsuntosPropiosComponent implements OnInit {
    form: UntypedFormGroup = null;
    title: string = "";
    constructor(
        private dialogRef: MatDialogRef<RechazarAsuntosPropiosComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.title = this.data.title;

        this.form = new UntypedFormGroup({
            rechazo: new UntypedFormControl('', Validators.required),
        });
    }

    ngOnInit(): void {
        this.title = this.data.title;
    }

    rechazar(): void {
        if (this.form.valid) {
            this.dialogRef.close(this.form.value.rechazo);
            this.form.reset();
        }
    }

    cancel(): void {
        this.dialogRef.close('');
    }
  public trackByIndex(i: number) { return i; }

}
